



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { loadStripe, Stripe, StripeElements } from '@stripe/stripe-js';
import { MathUtils } from '@/util/mathUtils';

@Component
export default class StripeCardPayment extends Vue {
  @Prop({ required: true }) private clientSecret!: string;
  @Prop({ required: true }) private amount!: string;

  private stripe: Stripe | null = null;
  private elements: StripeElements | null = null;
  private paymentElement: any | null = null;
  private isCardValid = true;
  private loading = false;
  private resultMessage = '';
  private paymentSuccess = false;
  private amountIn$ = '';

  @Watch('clientSecret')
  public async onClientSecretChange(newSecret: string) {
    if (this.stripe && newSecret) {
      this.initializeElements();
    }
  }

  private async mounted() {
    this.stripe = await loadStripe(this.$store.state.stripePublicKey);
    if (!this.stripe) {
      console.error('Stripe failed to load.');
      return;
    }

    this.elements = this.stripe.elements({
      clientSecret: this.clientSecret,
      appearance: {
        theme: 'stripe',
        labels: 'floating',
      },
    });

    this.paymentElement = this.elements.create('payment', {
      layout: 'tabs',
    });

    this.paymentElement.mount('#payment-element');

    this.paymentElement.on('change', (event: any) => {
      this.isCardValid = event.complete && !event.error;
    });
  }

  private initializeElements() {
    if (!this.stripe || !this.clientSecret) {return; }
    if (this.paymentElement) {
      this.paymentElement.unmount();
    }

    this.elements = this.stripe.elements({
      clientSecret: this.clientSecret,
      appearance: {
        theme: 'stripe',
        labels: 'floating',
      },
    });

    this.paymentElement = this.elements.create('payment', { layout: 'tabs' });
    this.paymentElement.mount('#payment-element');
    this.paymentElement.on('change', (event: any) => {
      this.isCardValid = event.complete && !event.error;
    });
  }

  private async handlePayment() {
    this.loading = true;
    this.resultMessage = '';

    if (!this.stripe || !this.elements) {
      return;
    }

    const { error, paymentIntent } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: 'if_required',
    });

    if (error) {
      this.resultMessage = error.message || 'Payment failed';
      this.paymentSuccess = false;
    } else if (paymentIntent && paymentIntent.status && paymentIntent.status === 'requires_capture') {
      this.resultMessage = 'Payment authorized successfully!';
      this.paymentSuccess = true;
      this.$emit('success', paymentIntent);
    }

    this.loading = false;
  }
}
